/**
 * Benannte Aufrufe statt freier Pfade (IS-32).
 *
 * Die **Typen** stammen alle aus `schema.d.ts` und damit aus dem OpenAPI-Schema
 * des Backends — hier steht keine einzige nachgebaute Feldliste. Handgeschrieben
 * ist nur die Zuordnung „Name → Pfad", und die ist an genau einer Stelle falsch,
 * wenn sie falsch ist.
 *
 * Der Zuschnitt spiegelt die Namensregel des Backends: der Name der
 * Endpoint-Funktion ist die Operation im Schema (`app/main.py:operation_id`).
 */
import { holen, senden } from './client'
import type { components } from './schema'

export type Nutzer = components['schemas']['UserResponse']
export type MeineSitzung = components['schemas']['MeResponse']
export type Anmeldung = components['schemas']['LoginResponse']
export type Betriebsbereitschaft = components['schemas']['HealthResponse']

/** Wer bin ich, was darf ich, steht der zweite Faktor. */
export const me = () => holen<MeineSitzung>('/api/auth/me')

/** Anmelden. Ohne CSRF-Token — es gibt noch keine Sitzung, gegen die eines prüfbar wäre. */
export const anmelden = (email: string, passwort: string) =>
  senden<Anmeldung>('/api/auth/login', { email, password: passwort })

export const abmelden = () => senden<void>('/api/auth/logout')

/** Zweiter Faktor bei der Anmeldung. Erzeugt serverseitig eine **neue** Sitzung. */
export const totpPruefen = (code: string) => senden<Anmeldung>('/api/auth/totp/verify', { code })

export const betriebsbereitschaft = () => holen<Betriebsbereitschaft>('/health')
